export default "__VITE_ASSET__8e291bd2__"